import React, { useMemo } from 'react';
import './OrdersHistoryContent.css';

// Функция для очистки названия игры от ссылок и лишних символов
const cleanGameName = (name) => {
  if (!name) return 'Пополнение';
  
  // Удаляем URL из строки
  let cleaned = name.replace(/https?:\/\/[^\s]+/g, '');
  
  // Удаляем лишние пробелы и переносы строк
  cleaned = cleaned.replace(/\s+/g, ' ').trim();
  
  // Если после очистки ничего не осталось, возвращаем дефолтное значение
  return cleaned || 'Пополнение';
};

// Функция для парсинга даты в формате dd.mm.yyyy
const parseDate = (dateStr) => {
  if (!dateStr || dateStr === '-') return new Date(0);
  const [day, month, year] = dateStr.split('.');
  return new Date(year, month - 1, day);
};

const OrdersHistoryContent = ({ orders = [], loading = false, error = null }) => {
  // Фильтруем только оплаченные заказы и сортируем от новейших к старейшим
  const paidOrders = useMemo(() => {
    return orders
      .filter(order => order.status === 'completed')
      .map(order => ({
        ...order,
        game: cleanGameName(order.game)
      }))
      .sort((a, b) => parseDate(b.date) - parseDate(a.date));
  }, [orders]);
  if (loading) {
    return (
      <div className="orders-history orders-history--loading">
        <div className="orders-history__spinner" />
        <p className="orders-history__loading-text">Загрузка заказов...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="orders-history orders-history--error">
        <div className="orders-history__error-icon">!</div>
        <p className="orders-history__error-text">{error}</p>
      </div>
    );
  }

  return (
    <div className="orders-history">
      {/* Заголовки таблицы */}
      <div className="orders-history__header">
        <div className="orders-history__header-cell">
          <span>Товар</span>
        </div>
        <div className="orders-history__header-cell">
          <span>Дата</span>
        </div>
        <div className="orders-history__header-cell">
          <span>Сумма</span>
        </div>
        <div className="orders-history__header-cell">
          <span>Номер заказа</span>
        </div>
      </div>

      {/* Разделитель */}
      <div className="orders-history__divider" />

      {/* Строки таблицы */}
      <div className="orders-history__body">
        {paidOrders.map((order, index) => (
          <React.Fragment key={order.id}>
            <div className="orders-history__row">
              <div className="orders-history__cell">
                <span className="orders-history__cell-game">{order.game}</span>
              </div>
              <div className="orders-history__cell">
                <span className="orders-history__cell-text">{order.date}</span>
              </div>
              <div className="orders-history__cell">
                <span className="orders-history__cell-text">{order.amount}</span>
              </div>
              <div className="orders-history__cell">
                <span className="orders-history__cell-text">{order.id}</span>
              </div>
            </div>
            {index < paidOrders.length - 1 && (
              <div className="orders-history__divider" />
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Пустое состояние */}
      {paidOrders.length === 0 && (
        <div className="orders-history__empty">
          <p>У вас пока нет заказов</p>
        </div>
      )}
    </div>
  );
};

export default OrdersHistoryContent;
